import Chip from "@mui/material/Chip";
import { alpha } from "@mui/material/styles";
import { styled } from "../../../../lib/styled";
import { TIER_COLOR, type ExtractionTier } from "@shared/scorecard";

export interface TierChipProps {
  tier: ExtractionTier;
}

const TierChipBase = styled(Chip)<{ $tier: ExtractionTier }>(({ $tier }) => {
  const color = TIER_COLOR[$tier];
  return {
    backgroundColor: alpha(color, 0.16),
    color,
  };
});

/**
 * Compact tag for an extraction tier, coloured by the shared TIER_COLOR convention (red/amber/grey)
 * so a tier reads as the same colour everywhere. Uses the app-wide soft-tint chip look: a light
 * wash of the tier colour with the tier colour as text, rather than a strong outlined badge.
 */
export function TierChip({ tier }: TierChipProps) {
  return <TierChipBase label={`Tier ${tier}`} size="small" $tier={tier} />;
}
